export default "__VITE_ASSET__CXzoNoCx__"